import { SvgIconComponent } from '@material-ui/icons';
import DashboardIcon from '@material-ui/icons/Dashboard';
import ProducerIcon from '@material-ui/icons/StoreMallDirectory';
import ProductIcon from '@material-ui/icons/LocalGroceryStore';
import OrderIcon from '@material-ui/icons/LocalShippingOutlined';
import ApprovalProductsIcon from '@material-ui/icons/PlaylistAddCheck';
import OrganizationsIcon from '@material-ui/icons/Business';
import ProducersApprovalIcon from '@material-ui/icons/AssignmentTurnedIn';
import PollIcon from '@material-ui/icons/Poll';
import ReportProblemOutlinedIcon from '@material-ui/icons/ReportProblemOutlined';
import HistoryOutlinedIcon from '@material-ui/icons/HistoryOutlined';
import CloudUploadOutlinedIcon from '@material-ui/icons/CloudUploadOutlined';
import ErrorIcon from '@material-ui/icons/Error';
import StorageIcon from '@material-ui/icons/Storage';
import ForumOutlinedIcon from '@material-ui/icons/ForumOutlined';
import MemoryOutlinedIcon from '@material-ui/icons/MemoryOutlined';
import InsightsIcon from '@material-ui/icons/TrendingUp';

export interface IMenuItem {
  title: string;
  icon: SvgIconComponent;
  // Heading shown above the first item of a group in the side menu.
  section?: string;
}

export interface IMenuItems {
  [key: string]: IMenuItem;
}

const MENU_ITEMS: IMenuItems = {
  dashboard: { title: 'Dashboard', icon: DashboardIcon },
  productAssistant: { title: 'Produktassistent', icon: ForumOutlinedIcon },
  insights: { title: 'Insights', icon: InsightsIcon },
  me: { title: 'Min profil', icon: ProducerIcon },
  meProducts: { title: 'Produkter', icon: ProductIcon },
  meBulkImport: { title: 'Bulkimport', icon: CloudUploadOutlinedIcon },
  producers: { title: 'Producers', icon: ProducerIcon },
  products: { title: 'Products', icon: ProductIcon },
  storeProducts: { title: 'My Products', icon: ProductIcon },
  storeAllProducts: { title: 'All Products', icon: ProductIcon },
  storeBulkImport: { title: 'Bulk Import', icon: CloudUploadOutlinedIcon },
  orders: { title: 'Orders', icon: OrderIcon },
  superuserProducts: {
    title: 'Product Approval',
    icon: ApprovalProductsIcon,
  },
  superuserTmp: {
    title: 'Descriptive size',
    icon: ApprovalProductsIcon,
  },
  failedProducts: {
    title: 'Failed Products',
    icon: ReportProblemOutlinedIcon,
  },
  // superuserExportProducts: {
  //     title: 'Export Products',
  //     icon: RestoreIcon,
  // },
  // superuserExportNonFoodProducts: {
  //     title: 'Export Non Food',
  //     icon: RestoreIcon,
  // },
  superuserProducers: {
    title: 'Producers Approval',
    icon: ProducersApprovalIcon,
  },
  superuserAllProducts: { title: 'All Products', icon: ProductIcon },
  superuserAllOrganizations: {
    title: 'Organizations',
    icon: OrganizationsIcon,
  },
  superuserAllProducers: { title: 'All Producers', icon: ProducerIcon },
  producerData: { title: 'Data', icon: PollIcon },
  superuserErrors: { title: 'Errors', icon: ErrorIcon },
  exportHistory: { title: 'Coop Export History', icon: HistoryOutlinedIcon },
  icaExportHistory: { title: 'ICA Export history', icon: HistoryOutlinedIcon },
  // bulkImport: { title: 'Bulk import', icon: CloudUploadOutlinedIcon },
  bulkImportNew: { title: 'Bulk import', icon: CloudUploadOutlinedIcon },
  superuserBulkReview: { title: 'Bulk Review', icon: ApprovalProductsIcon },
  superuserSettingsAi: { title: 'AI', icon: MemoryOutlinedIcon, section: 'Settings' },
  superuserStatistics: { title: 'Statistics', icon: PollIcon, section: 'Settings' },
  superuserDatabase: { title: 'Database', icon: StorageIcon, section: 'Settings' },
};

export default MENU_ITEMS;
